import RegulateLogo from "../../../assets/home/reguateLogo.svg";
import Step1 from "../../../assets/home/Step1.svg";
import Step2 from "../../../assets/home/Step2.svg";
import Step3 from "../../../assets/home/Step3.svg";
import Step4 from "../../../assets/home/Step4.svg";
import upRightArrow from "../../../assets/up-right-arrow-white.svg";
import upRightBlue from "../../../assets/up-right-arrow.svg";
import "./style.css";

export default function WorkFlow() {
  const content = [
    {
      id: 1,
      title: `<div>Programmable <br /> Compliance Logic</div>`,
      additionalInfo: `<div>Automates claims, ingredients, and regulatory checks - <span style="font-weight: 500;">like Stripe for regulated products.</span></div>`,
      icon: Step1,
      background: `linear-gradient(
        180deg,
        #dee2ff 0%,
        rgba(222, 226, 255, 0.2) 100%
      )`,

    },
    {
      id: 2,
      title: "<div>Demand-Led <br/> Execution Engine</div>",
      additionalInfo: `<div>Live consumer signals guide what gets built - <span style="font-weight: 500;">reducing risk and driving conversion.</span></div>`,
      icon: Step2,
      background: `linear-gradient(180deg, #D0E5FE 0%, rgba(208, 229, 254, 0.20) 100%)`,
    },
    {
      id: 3,
      title: `<div>Verified System of <br/> Record</div>`,
      additionalInfo: `<div>Real-time source of truth for formulas, specs, and label logic - <span style="font-weight: 500;">no spreadsheets, no delays</span>.</div>`,
      icon: Step3,
      background: `linear-gradient(180deg, #FCF5E9 0%, rgba(252, 245, 233, 0.20) 100%)
`,
    },
    {
      id: 4,
      title: `<div>Embedded Trust <br/> Controls</div>`,
      additionalInfo: `<div>Compliance embedded at every step - <span style="font-weight: 500;">validating readiness for market, instantly</span></div>`,
      icon: Step4,
      background: `linear-gradient(180deg, #EAF6F1 0%, rgba(234, 246, 241, 0.20) 100%)`,
    },
  ];

  return (
    <div
      className="d-flex justify-content-center"
      style={{
        background: "#F7F9FA",
      }}
    >
      <div className="commonInlinePadding paddingBlockLaunch section-container">
        <div className="flexCenter">
          <div className="boxContainer">
            <img src={RegulateLogo} alt="RegulateLogo" />
            <span className="typography">WorkFlow</span>
          </div>
        </div>

        <div className="problemHeading off-black fourSteps">
          From Concept to Consumer <br /> in{" "}
          <span style={{ color: `var(--Green-Accent)` }}>Four Steps</span>
        </div>

        <div className="fourStepContainer">
          {content?.map((item, index) => {
            return (
              <div
                className={`stepContainer stepContainer-${item?.id} stepContainerBgImage-${item?.id}`}
              // style={{ background: item?.background }}
              >
                <div
                  className="stepNumberContainer medium"
                  style={{ color: "car(--Primary-Deep-Blue)" }}
                >
                  {`STEP ${index + 1}`}
                </div>

                <div
                  className="stepHeader off-black"
                  dangerouslySetInnerHTML={{ __html: item?.title }}
                />

                <div
                  className="off-black typography moreDescription"
                  style={{ fontWeight: "400" }}
                  dangerouslySetInnerHTML={{ __html: item?.additionalInfo }}
                />

                <div className="imageIcon">
                  <img
                    src={item?.icon}
                    alt={`Step ${item?.id}`}
                    style={{ width: "5rem" }}
                  />
                </div>
              </div>
            );
          })}
        </div>

        <div className="flexCenter hoverBUttonLearn" style={{ marginTop: "3.75rem" }}>
          <button
            className="btn btn-outline-primary buttonText learnHowBtnWF"
            style={{ border: "none", fontSize: "24px" }}
            onClick={() => {
              window.open(
                "https://meetings.hubspot.com/carly-weitz/insight-suite?uuid=054daf27-08e5-45ad-95f3-6ba7c6569d95",
                "_blank"
              );
            }}
          >
            Learn how Regulate CPG workflow works
            <img src={upRightBlue} alt="Arrow" className="icon-default" />
            <img src={upRightArrow} alt="Arrow" className="icon-hover" />
          </button>
        </div>
      </div>
    </div>
  );
}
